export const imageMotion = {
    initial: {
        opacity: 0,
        y: 20,
    },
    animate: {
       opacity: 1,
       y: 0,
       transition: {
           duration: .5,
           delay: .7, 
       }
    },
    exit: {
        opacity: 0,
        y: 10,
        transition: {
            duration: .5
        }
    }
}